module.exports = __webpack_public_path__ + "img/392.1393fee4.jpg";